import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="click-to-edit-box"
export default class extends Controller {
  connect() {
    this.element.setAttribute("title", "Click to edit");
  }

  clickFirstLink() {
    this.element.getElementsByTagName("a")[0].click();
  }
}
